import { render, staticRenderFns } from "./CadastrarEditarProfissionalDialog.vue?vue&type=template&id=0e6825b2&scoped=true"
import script from "./CadastrarEditarProfissionalDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarProfissionalDialog.vue?vue&type=script&lang=js"
import style0 from "./CadastrarEditarProfissionalDialog.vue?vue&type=style&index=0&id=0e6825b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6825b2",
  null
  
)

export default component.exports